export interface IEventSubscription {
    unsubscribe(): void;
    }

export class EventEmitter<TSender, TArgs> {
    private subsribers: ((sender: TSender, args: TArgs) => void)[] = [];

emit(sender: TSender, args: TArgs): void {
    this.subsribers.forEach(subscriber => subscriber(sender, args));
}

subscribe(callback: (sender: TSender, args: TArgs) => void): IEventSubscription {
    this.subsribers.push(callback);
    var self = this;
    return {
        unsubscribe() {
            var index = self.subsribers.indexOf(callback);
            if (index < 0)
                return;
            self.subsribers.splice(index, 1);
        }
    }
}
}